import { atom } from 'recoil';

export const driversListState = atom({
  key: 'driversListState',
  default: [],
});
